import React, { ReactElement, useState } from "react";
import { GQLCategories, Maybe, GQLOffers, GQLUrls } from "@gql/types/gql";
import Link from "@components/shared/linkNoPrefetch";
import UpArrow from "../icons/upArrow";
import styles from "./style.module.scss";
import { useQuery } from "@tanstack/react-query";
import { translate } from "@helpers/translationObjectFormatter";
import {
    ICategoriesPageProp,
    TranslationsObject,
} from "@genericTypes/sharedTypes";
import { resolveURL } from "@lib/sharedUtils";
import AnimateHeight from "../animateHeight";

export interface DomainOffer {
    categoryId: number;
    offers: GQLOffers[];
}
export default function CategoryItem({
    item,
    className,
    url,
}: {
    item: GQLCategories;
    className?: string;
    url: string;
}): ReactElement {
    const [opened, setOpen] = useState(false);
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);
    const { data: pageProps } = useQuery<ICategoriesPageProp, Error>({
        queryKey: ["categoriesPageProps"],
    });

    const { domainOffers } = pageProps ?? {};

    const offers = domainOffers
        ?.filter((domainOffer) => domainOffer.categoryId === item.id)
        .flatMap((item) => item.offers);

    return (
        <div
            className={` flex flex-col rounded-lg ${styles["categoryStyle"]} lg:px-11 px-7 py-3 my-3`}
        >
            <Link
                href={`${url}`}
                className={` w-fit font-bold lg:text-xl text-lg leading-7 lg:leading-[50px] ${styles["categoryNameColor"]}`}
            >
                {item.label ?? item.name}
            </Link>

            <div
                onClick={() => setOpen(!opened)}
                className={`flex justify-between items-baseline mt-2 cursor-pointer ${
                    className ?? ""
                }`}
            >
                <div className="font-medium lg:text-lg lg:leading-9">
                    {opened
                        ? translate(
                              translations,
                              "several_categoriesPage_hideVendors",
                          )
                        : translate(
                              translations,
                              "several_categoriesPage_showVendors",
                          )}
                </div>
                <span
                    className={`${styles.arrow} ml-3 w-3 lg1048:w-5 ${
                        opened ? "" : "rotate-180"
                    } transition`}
                >
                    <UpArrow />
                </span>
            </div>
            {
                <AnimateHeight duration={500} height={opened ? "auto" : 0}>
                    <div className={`mt-5 lg:ml-7 ml-5 lg:mb-14`}>
                        {offers?.map(
                            (offer: Maybe<GQLOffers>, index: number) => (
                                <div
                                    key={index}
                                    className={`flex items-center  ml-3 `}
                                    itemScope
                                    itemType="https://schema.org/Offer"
                                >
                                    <span
                                        className={`h-[6px] w-[6px] min-w-[6px] rounded-full block bg-[#1693f0]`}
                                    ></span>
                                    <Link
                                        href={`${resolveURL(
                                            offer?.url as GQLUrls,
                                        )}`}
                                        className={`block px-4 py-2 ${styles["categoryNameColor"]} lg:text-lg text-sm`}
                                        itemProp="name"
                                    >
                                        {offer?.name ??
                                            offer?.summaryTitle ??
                                            offer?.title ??
                                            ""}
                                    </Link>
                                </div>
                            ),
                        )}
                        <div>
                            <Link
                                href={`${url}`}
                                className={`${styles["categoryNameColor"]} block  py-2  text-sm lg1048:text-lg`}
                            >
                                {translate(
                                    translations,
                                    "several_general_showMoreButton",
                                )}
                            </Link>
                        </div>
                    </div>
                </AnimateHeight>
            }
        </div>
    );
}
